<template>
  <component :is="hasHash ? 'a' : NavLink" :href="redirectUrl" class="cta" :variant="variant">
    <div class="text">{{ text }}</div>
    <Button class="button" :id="buttonId" color="white" :text="buttonText" />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Button from '@/components/Theme2/Button.vue'
import NavLink from '@/components/NavLink.vue'
import { Routes } from '@/constants'

const props = withDefaults(
  defineProps<{
    text?: string
    buttonId?: string
    buttonText?: string
    redirectUrl?: string
    variant?: 'green' | 'blue' | 'blue-2' | 'red' | 'yellow'
  }>(),
  {
    text: 'Want to launch your trip?',
    buttonText: 'Plan a trip',
    redirectUrl: Routes.PlanATrip,
    variant: 'blue',
  },
)

const hasHash = computed(() => props.redirectUrl.includes('#'))
</script>

<style lang="scss" scoped>
.cta {
  background: linear-gradient(90deg, $brand-primary 0%, #3a6fc4 100%);
  border-radius: 24px;
  display: flex;
  padding: 47.5px 32px 47.5px 33px;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  &[variant='green'] {
    background: linear-gradient(90deg, $green-300 0%, $green-100 100%);
  }

  &[variant='blue-2'] {
    background: linear-gradient(90deg, $brand-primary 0%, #538c97 100%);
  }

  &[variant='yellow'] {
    background: linear-gradient(89deg, #f1c40f -1.57%, #f9e79d 102.36%);

    .text {
      color: $grey-300;
    }
  }

  &[variant='red'] {
    background: $red-300;
  }

  @include mobile {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
  }

  .text {
    color: white;
    font-size: 32px;
    font-weight: 600;
    line-height: 110%;
  }

  .button {
    flex-shrink: 0;
  }
}
</style>
